<script>
  import SubFooter from 'src/pc/components/SubFooter'
  import DisplayContainer from '../components/DisplayContainer'
  export default {
    extends: SubFooter,
    components: {
      DisplayContainer
    },
  }
</script>

<style>
	.ad_bottom {
		margin: 0 !important;
		padding: 0 !important;
	}
	.ad_bottom .ad_wrap {
		margin: 0 !important;
		padding: 30px 0 !important;
    text-align: center;
	}
	.ad_bottom .ad_wrap a {
		padding: 20px 0 !important;
	}
	.ad_bottom > div {
		width: unset !important;
		height: auto !important;
	}
	.ad_bottom .display-container a > img {
		max-width: 320px !important;
	}

  .ad_wrap.footer .inner a img {
    width: 250px !important;
    height: 250px !important;
  }
</style>
